
























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import VueBarcode from 'vue-barcode';
import Print from 'vue-print-nb'
Vue.use(Print);
@Component({
    components:{ 'barcode': VueBarcode}
})
export default class BarCode extends AbpBase{
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: String, default: "" }) code: String;
   @Prop({ type: Number, default: 1 }) qty: number;
    @Prop({ type: Number, default: 1 }) width: number;
    @Prop({ type: Number, default: 30 }) height: number;
    @Prop({ type: String, default: "svg" }) type: String;
    @Prop({ type: String, default: "Arial" }) font: String;
    @Prop({ type: String, default: "12" }) fontSize: String;
    @Prop({ type: Boolean, default: true }) isPrinter: boolean;
    options:any= {
        format: 'CODE128',
        background: '#fff'
    }
    created()
    {
       this.code = Util.isNull(this.code)? "": this.code;
    }
}
